(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compact-luxury-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const items = document.querySelectorAll(".luxury-faq-item");
  items.forEach(item => {
    const question = item.querySelector(".luxury-faq-question");
    question.addEventListener("click", function() {
      const isActive = item.classList.contains("active");
      
      // Close all
      items.forEach(i => {
        i.classList.remove("active");
        i.querySelector(".luxury-faq-answer").style.maxHeight = null;
      });

      // Toggle current
      if (!isActive) {
        item.classList.add("active");
        const answer = item.querySelector(".luxury-faq-answer");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
